module.exports = __webpack_public_path__ + "static/img/controlbox.57f6920.png";


//////////////////
// WEBPACK FOOTER
// ./img/project-design/controlbox.png
// module id = 1022
// module chunks = 1